import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { applyPageMeta } from '../seo/meta.js';
import { resolveRouteMeta } from '../seo/routeMeta.js';

export default function RouteMetaManager() {
  const location = useLocation();

  useEffect(() => {
    applyPageMeta(resolveRouteMeta(location.pathname));
  }, [location.pathname]);

  return null;
}